import { render, staticRenderFns } from "./TickerDetailsListAvailable.vue?vue&type=template&id=530779dc&scoped=true"
import script from "./TickerDetailsListAvailable.vue?vue&type=script&lang=ts"
export * from "./TickerDetailsListAvailable.vue?vue&type=script&lang=ts"
import style0 from "./TickerDetailsListAvailable.vue?vue&type=style&index=0&id=530779dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530779dc",
  null
  
)

export default component.exports